import angular from 'angular';
import constants from 'app/constants';
import {
  alerts
} from 'app/components/global';
import {
  oversightDataService,
  loaderService,
  ssDialogService,
  userService
} from 'app/services';
import controller from './attach-agendaItem-report.controller';
import directive from './attach-agendaItem-report.directive';


export default angular.module('app.components.advisory.oversight.attachAgendaItemReport', [
  alerts,
  oversightDataService,
  constants,
  loaderService,
  ssDialogService,
  userService,
])
  .directive('attachAgendaItemReport', directive)
  .controller('AttachAgendaItemReportController', controller)
  .name;

console.log('app.components.advisory.oversight.attachAgendaItemReport created');
